// extracted by mini-css-extract-plugin
module.exports = {"RatingCardContainer":"_1VFa2Hx-4TJtSotrFiwxlk","RatingInfo":"CCUlUVsyUB4_jsWETSQlW","CardName":"_1JiAUUv8ql4jzVsU8lOlCI","CardComment":"_2uwiWoJyDV_UzQ9DxtBIIJ"};